import { api } from 'shared/api'
import { BroadcastingApiSchemas } from 'shared/api/requests/broadcasting/schemas'

export const BroadcastingApi = {
  loadScheduled: api.account.createGet({
    url: '/broadcasting/loadScheduled',
    schemas: BroadcastingApiSchemas.loadScheduled,
  }),
  loadHistory: api.account.createGet({
    url: '/broadcasting/loadHistory',
    schemas: BroadcastingApiSchemas.loadHistory,
  }),
  loadDrafts: api.account.createGet({
    url: '/broadcasting/loadDrafts',
    schemas: BroadcastingApiSchemas.loadDrafts,
  }),
  copy: api.account.createGet({
    url: '/broadcasting/copy',
    schemas: BroadcastingApiSchemas.copy,
  }),
  create: api.account.createPost({
    url: '/broadcasting/create',
    schemas: BroadcastingApiSchemas.create,
  }),
  schedule: api.account.createGet({
    url: '/broadcasting/schedule',
    schemas: BroadcastingApiSchemas.schedule,
  }),
  unschedule: api.account.createGet({
    url: '/broadcasting/unschedule',
    schemas: BroadcastingApiSchemas.unschedule,
  }),
  interrupt: api.account.createGet({
    url: '/broadcasting/interrupt',
    schemas: BroadcastingApiSchemas.interrupt,
  }),
  forceSending: api.account.createGet({
    url: '/broadcasting/forceSending',
    schemas: BroadcastingApiSchemas.forceSending,
  }),
  update: api.account.createPost({
    url: '/broadcasting/update',
    schemas: BroadcastingApiSchemas.update,
  }),
  load: api.account.createGet({
    url: '/broadcasting/load',
    schemas: BroadcastingApiSchemas.load,
  }),
  delete: api.account.createGet({
    url: '/broadcasting/delete',
    schemas: BroadcastingApiSchemas.delete,
  }),
}
